import Gutenslider from './gutenslider';

function domReady( callback ) {
	if ( typeof document === 'undefined' ) {
		return;
	}

	if (
		document.readyState === 'complete' || // DOMContentLoaded + Images/Styles/etc loaded, so we call directly.
		document.readyState === 'interactive' // DOMContentLoaded fires at this point, so we call directly.
	) {
		return void callback();
	}

	document.addEventListener( 'DOMContentLoaded', callback );
}

domReady( function() {
	const gutensliders = document.querySelectorAll( '.wp-block-eedee-block-gutenslider' );
	[ ...gutensliders ].forEach( function( gs ) {
		gs.gutenslider = new Gutenslider( gs );
	});
} );
